import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
import { getChartData, getDatasourceAndDates } from '../../../api';

import { xlsxCustomExport } from '../utils/chartConfig';

const IMG_URL = process.env.IMG_FULL_URL;

const euColor = '#003399';
const country1Color = '#ffae00';
const country2Color = '#529FA2';
const country3Color = '#7b7b7d';
class Chart extends Component {
	constructor(props) {
		super(props);

		let stackedBarWidth = undefined;
		if (props.stacking)
		{
			if (props.fullCountryReport)
			{
				stackedBarWidth = 35;
			}
			else
			{
				stackedBarWidth = 15;
			}
		}

		this.state = {
			chartConfig: {
				styledMode: true,
				title: {
					//useHTML: true,
					text: "<h2 class='title--card'>"+this.props.title+"</h2>",
					align: 'left',
					widthAdjust: 0,
					style: {
						zIndex: 1,
						lineHeight:36
					}					
				},
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
				},
				colors: this.props.colors,
				chart: {
					// height: this.props.fullCountryReport ? 450 : 250,
					//width: 300,
					type: this.props.type,
					backgroundColor: '#F0F0F0',
					events: {
					 	render: function() {
					 	  	let chart = this;
							if (!chart.customImage)
							{
								chart.customImage = chart.renderer.image(
									`${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
									chart.chartWidth - 130,
									chart.chartHeight - 37,
									130,
									37
								).add();
								chart.customImage.attr({
									class:'osha-logo'
								});
							}
							else
							{
								chart.customImage.attr({
									x: chart.chartWidth - 130,
									y: chart.chartHeight - 37
								});
							}

							if (chart.fullscreen.isOpen) {
								chart.customImage.css({
									display: 'block'
								});
								chart.container.className = 'highcharts-container full-screen';
						  	}
							else
							{
								chart.customImage.css({
									display: ''
								});	
								chart.container.className = 'highcharts-container';
							}
					 	}					
					},
				},
				exporting: {
					enabled: this.props.fullCountryReport,
					sourceHeight: 1100,
					sourceWidth: 720,
					y:-10,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
					menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Size', this.series, this.title.textStr);
                            }
                        }
                    },
					chartOptions:
					{
						credits: {
							enabled: true
						}
					}
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y:-5
					}
				},
				legend:{
					verticalAlign: 'bottom',
					symbolRadius: 0,
					//layout: 'vertical',
					itemMarginTop: 4,
					itemMarginBottom:4,
					// width: this.props.fullCountryReport ? 300 : 250,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:'12px',
						textOverflow: "ellipsis",
						width: this.props.fullCountryReport ? 250 : 150
					}
				},
				plotOptions: {					
					series: {
						shadow: false,
						outline: 0,
						stacking: this.props.stacking,
						dataLabels: {
							allowOverlap: true
						  }
						//pointPadding: 0.25
					},
					column: {
						stacking: this.props.stackingColumn,
						borderWidth: 0,
						pointPadding: 0.1
					},
					bar: {
						minPointLength:3,
						groupPadding:0.06,
						borderWidth: 0,
						pointWidth: stackedBarWidth,
						dataLabels: {
							align: 'left',
							y:0,
							inside: false,
							overflow: 'none',
							crop: false,
							textOutline: 0,
							style: {
								textOutline: 0,
								textShadow: false,
								fontFamily: 'OpenSans-Bold',
								fontSize:'14px'
							},
							enabled: this.props.showDataLabel === true ? true : false,
							formatter: function () {
								return '<span class="data-labels" style="color:' + this.point.color + '">' + this.y + '%</span>';
							}
						}
					}
				},
				tooltip: {					
					useHTML: true,
					opacity: 1,
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor:"#529FA2",
					zIndex: 100,
					style: {
						zIndex: 100
					},
					formatter: function () {
						return '<ul class="tooltip-item">'+
						'<li><strong>'+props.title+': </strong><br>' + this.series.name +'</li>'+
						'<li><strong>Country: </strong> ' + this.x + '</li>' +
						'<li><strong class="tooltip-value"> Value: </strong>' + this.y +'%</li>' +
						'</ul>';
					},
				},
				xAxis: {
					lineWidth: 0,
					categories: [this.props.data?.categories],
					
					labels: {
						formatter: function () {
							if ([this.value] == 'EU27' || [this.value] == 'EU28') {
								return "<span style='color:" + euColor + "'>" + [this.value] + "</span>"
							}else{
								if([this.pos] == 0){
									return "<span style='color:" + country1Color + "'>" + [this.value] + "</span>";
								} else if([this.pos] == 1)
								{
									return "<span style='color:" + country2Color + "'>" + [this.value] + "</span>";
								}
								else{
									return "<span style='color:" + country3Color + "'>" + [this.value] + "</span>";
								}
							}
						},
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize:'12px'
						}
					}
				},
				yAxis: {
					gridLineColor:'#FFF',
					gridLineWidth:2,
					reversedStacks: false,
					reversed: this.props.reversed,
					max: 100,
					tickInterval: this.props.tick,
					title: {
						enabled: false
					},
					labels: {
						format: this.props.percentage === true ? '{value}%' : `{value}${this.props.percentage}`,
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize:'12px',
							textOverflow: 'none'
						}
					}
				},
				series: [ ]
			}
		}
	}

	getLoadData = (chart, indicator, country1, country2, country3, dataset) => {
		let categories = [];
		let auxSeries = [];
		let series = [];
		
		let requestFilter = {
			chart,
			indicator, 
			country1,
			country2,
			country3,
			dataset
		}
		getChartData(requestFilter)
			.then((res) => {
				
				res.resultset.forEach(element => {
					if (categories.indexOf(element.countryCode) == -1) {
						if (element.countryCode == "EU27_2020")
						{
							categories.push(element.country);
						}
						else
						{
							categories.push(element.countryCode);
						}						
					}
					
					let split = element.split;
					if (!(split in auxSeries)) {
						auxSeries[split] = []
						
					}auxSeries[split].push(element.value)
					 
				});
					
		for (let serie in auxSeries) {
			
			series.push({ name: serie , data: auxSeries[serie] })
		}

		this.setState({
			chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series}
		})
	});
		
	}

	getCredits = (chart, dataset) => {
		getDatasourceAndDates(chart, dataset).then((res)=>{
			let text = res;
			this.setState({
				chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
			})
		})		
	}

	componentDidMount() {
		this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset);
		this.getCredits(this.props.chart, this.props.dataset);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 || prevProps.selectCountry3 != this.props.selectCountry3 || prevProps.dataset != this.props.dataset) {
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset);

			if (this.props.stacking && this.props.selectCountry3 != "" && this.props.selectCountry3 != undefined)
			{
				// Three countries are selected, make the bars in stacking thinner
				this.setState({ chartConfig: {...this.state.chartConfig, plotOptions: {...this.state.chartConfig.plotOptions, bar: {...this.state.chartConfig.plotOptions.bar, pointWidth: 19 } } } });
			}
		}

		if (prevProps.dataset != this.props.dataset)
		{
			this.getCredits(this.props.chart, this.props.dataset);
		}
	}

	render() {
		// There is a known bug with the Full Screen option, when exiting the chart takes the full height and width of the screen
		// In order to fix it, add a className to the Highcharts element in the containerProps and set a fixed height (in pixels) in the CSS
		// Do not set the height of the chart in the options. If so, when going full screen, it will only take the height configured in the options
		return (
			<div className='chart-container'>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.state.chartConfig}
					containerProps={{ className: 'chartContainer' }}
				/>
				
			</div>
		)
	}
}
Chart.defaultProps = {
	fullCountryReport: true,
	title: ''
}

export default Chart;